"use strict";

import _get from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { arrayify, hexlify } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder";
export var DynamicBytesCoder = /*#__PURE__*/function (_Coder) {
  _inherits(DynamicBytesCoder, _Coder);

  var _super = _createSuper(DynamicBytesCoder);

  function DynamicBytesCoder(type, localName) {
    _classCallCheck(this, DynamicBytesCoder);

    return _super.call(this, type, type, localName, true);
  }

  _createClass(DynamicBytesCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      value = arrayify(value);
      var length = writer.writeValue(value.length);
      length += writer.writeBytes(value);
      return length;
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.readBytes(reader.readValue().toNumber(), true);
    }
  }]);

  return DynamicBytesCoder;
}(Coder);
export var BytesCoder = /*#__PURE__*/function (_DynamicBytesCoder) {
  _inherits(BytesCoder, _DynamicBytesCoder);

  var _super2 = _createSuper(BytesCoder);

  function BytesCoder(localName) {
    _classCallCheck(this, BytesCoder);

    return _super2.call(this, "bytes", localName);
  }

  _createClass(BytesCoder, [{
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, hexlify(_get(_getPrototypeOf(BytesCoder.prototype), "decode", this).call(this, reader)));
    }
  }]);

  return BytesCoder;
}(DynamicBytesCoder);